import * as React from "react";

const SvgComponent = ({ color = "#636F7C", ...props }) => (
  <svg
    width={15}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.667 2.727C10.664 1.403 8 1.102 5.789 1.5 3.314-.886.54.21 0 .527c0 0 1.903 1.617 1.594 3.034-2.253 2.297-1.182 4.854 0 6.062C1.904 11.039 0 12.656 0 12.656c.536.317 3.301 1.411 5.789-.963 2.207.396 4.87.098 6.878-1.229 3.106-1.982 3.116-5.745 0-7.738ZM7.66 10.452a8.846 8.846 0 0 1-2.295-.296l-.514.497a4.684 4.684 0 0 1-.953.713c-.42.212-.878.342-1.347.384.026-.047.049-.093.072-.137.515-.955.654-1.811.417-2.57-.847-.667-1.354-1.52-1.354-2.451 0-2.136 2.675-3.865 5.974-3.865 3.299 0 5.974 1.73 5.974 3.865 0 2.135-2.675 3.86-5.974 3.86Zm-2.866-2.94a.894.894 0 0 1-.906-.879c-.019-1.182 1.766-1.208 1.784-.028v.013a.885.885 0 0 1-.878.894Zm1.92-.879c-.02-1.182 1.765-1.21 1.786-.031v.016c.01 1.174-1.765 1.187-1.785.015Zm3.735.878a.894.894 0 0 1-.907-.878c-.018-1.182 1.767-1.208 1.785-.028v.013a.882.882 0 0 1-.878.894Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;